import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    height: auto;
  `}
`;

export const ResultHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 15px;
    font-family: 'Poppins';

    .criteria {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;

      .category {
        font-weight: 600;
        font-size: 16px;
      }

      .location,
      .dates {
        font-size: 13px;
        color: #6b7280;
      }
    }

    .edit {
      background: none;
      border: none;
      /* mesmo azul do botao Detalhes (ThemeButton .button-select), nao o coral do tema */
      color: #1392EC;
      font-weight: 600;
      font-size: 14px;
      cursor: pointer;
      font-family: 'Poppins';
    }
  `}
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0;
`;
